import type { KeyboardEvent, VFC } from 'react'
import { Spacing } from '@opallabs/gem'
import { Checkbox, Icon } from '@opallabs/lapidary'
import type { WithTheme } from '@opallabs/lapidary'
import * as styles from './styles'

type UserSegmentCardProps = Readonly<
  WithTheme & {
    clickable: boolean
    description: string
    icon: string
    name: string
    onSelect: () => void
    selected: boolean
  }
>

export const UserSegmentCard: VFC<UserSegmentCardProps> = ({
  clickable,
  description,
  icon,
  name,
  onSelect,
  selected,
  theme = 'light',
}) => {
  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (clickable && e.key === 'Enter') {
      onSelect()
    }
  }

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
  return (
    <li
      onClick={() => clickable && onSelect()}
      css={styles.card({ selected, clickable, theme })}
    >
      <div css={styles.decoration}>
        <Checkbox
          checked={selected}
          disabled={!clickable}
          htmlId={`role-${name}`}
          labedlledbyId={`role-${name}-label`}
          onChange={() => clickable && onSelect()}
          size={Spacing.L}
          css={styles.checkbox}
          {...{
            onKeyDown,
            theme,
          }}
        />
        <Icon
          ariaHidden
          glyph={icon}
          height={30}
          styleOverrides={{
            container: styles.icon,
          }}
          width={30}
        />
      </div>
      <label
        aria-hidden
        htmlFor={`role-${name}`}
        id={`role-${name}-label`}
        css={styles.description}
      >
        {description}
      </label>
    </li>
  )
  /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
}
